import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../context/authContext';
import TablaMatrizContainer from '../components/TablaMatrizContainer';

export default function BaseMatrizPage() {
  const { role, token } = useContext(AuthContext);
  const [datos, setDatos] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (role !== 'admin') return;
    const fetchMatriz = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await fetch('/api/base-matriz', {
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });
        if (!res.ok) throw new Error('Error al cargar la Base Matriz');
        const data = await res.json();
        setDatos(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchMatriz();
  }, [role, token]);

  if (role !== 'admin') {
    return (
      <div className="p-8 text-center text-gray-500">
        Acceso denegado. Solo administradores.
      </div>
    );
  }

  return (
    <div className="p-6 w-full max-w-full">
      <h1 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4">
        Base Matriz
      </h1>
      {loading && <p className="text-gray-500 mb-4">Cargando datos...</p>}
      {error && <p className="text-red-600 mb-4">{error}</p>}
      <TablaMatrizContainer datos={datos} token={token} />
    </div>
  );
}
